module.exports = __webpack_public_path__ + "static/media/bre.3e75464a.jpg";